import React from 'react';

const DriveTopBar = () => {
  return (
    <nav
      className="navbar"
      style={{
        backgroundColor: '#1D1D1D',
        height: '50px',
      }}
    >
      <div className="text-white container h4">Drive </div>
    </nav>
  );
};

export default DriveTopBar;
